import { initDB } from "./offline";

const requestNotificationPermission = async () => {
  if (!("Notification" in window)) {
    return "unsupported";
  }

  if (Notification.permission === "granted") {
    return "granted";
  }

  const permission = await Notification.requestPermission();
  return permission;
};

const showNotification = (title, body) => {
  if (Notification.permission === "granted") {
    new Notification(title, {
      body,
      icon: "/manifest.json",
      tag: "nature-journal-reminder"
    });
  }
};

const scheduleReminder = async (hour, minute) => {
  const now = new Date();
  let scheduledTime = new Date(now);
  scheduledTime.setHours(hour, minute, 0, 0);

  if (scheduledTime <= now) {
    scheduledTime.setDate(scheduledTime.getDate() + 1);
  }

  const delay = scheduledTime.getTime() - now.getTime();

  const db = await initDB();
  await db.put("settings", { key: "reminderTime", hour, minute, enabled: true });

  setTimeout(() => {
    showNotification("Daily Nature Journal Reminder", "Have you documented any nature observations today?");
    scheduleReminder(hour, minute);
  }, delay);

  return scheduledTime;
};

export { requestNotificationPermission, scheduleReminder, showNotification };
